import { ADD_ONEITSM_SERVICE_NAME} from "../actionTypes";
import { addOneITSMServiceName } from "../../../api/userManagement/getAllCustomerList.service";

const request = () => ({ type: ADD_ONEITSM_SERVICE_NAME.REQUEST });
const failure = (error) => ({ type: ADD_ONEITSM_SERVICE_NAME.FAILURE, error });
const success = () => ({ type: ADD_ONEITSM_SERVICE_NAME.SUCCESS });

export const addOneItsmServiceName = (payload,requestId) => {
  return (dispatch, getState) => {
    dispatch(request());
    return addOneITSMServiceName(payload,requestId)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      });
  };
};